import MainHeader from '@/components/layout/MainHeader'

/**
 * LOGISPRD-12506 — 검수 피드백으로 어드민 글로벌 헤더를 콘솔에 그대로 붙인다(`ConsoleShell.tsx` 주석 참고).
 *
 * 라우터는 감싸지 않는다 — 어드민 라우트(`ConsolePage`)가 이미 App 의 `BrowserRouter` 안이라
 * 여기서 또 감싸면 중첩 Router 로 react-router 가 막는다. `MainHeader` 는 어드민 공용 컴포넌트라
 * 수정하지 않고 prop 으로만 제어한다.
 *
 * 콘솔 전용 CSS 래퍼는 두지 않는다. 예전에는 콘솔 폼 리셋이 헤더 안 `SelectBoxApi` 의 `<select>`
 * 까지 닿아 폭·패딩을 되돌리는 보정이 필요했는데, 그 리셋을 `.moms-console-body`(헤더를 뺀 본문)
 * 로 좁히면서 헤더는 어드민과 완전히 같은 스타일만 받는다 — 보정할 것이 없다.
 *
 * 자기 링크(온콜 콘솔 ↗)와 화주 전환 버튼은 더 이상 CSS 셀렉터로 숨기지 않는다(속성/빈 콘텐츠에
 * 기대는 방식은 헤더에 다른 외부 링크가 추가되거나 버튼 내용이 바뀌면 의도와 무관하게 사라지거나
 * 다시 나타난다 — 온콜 도구에서 조용한 오작동이 특히 나쁘다). 대신 `MainHeader` 에 옵셔널 prop
 * (`showConsoleLink`/`showShipperConvert`, 기본값 true = 기존 어드민 동작과 동일)을 추가해 여기서
 * 명시적으로 끈다.
 */
export const ConsoleHeader = (): JSX.Element => <MainHeader showConsoleLink={false} showShipperConvert={false} />
